import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative">
      {/* Top Border Gradient */}
      <div className="h-1 bg-gradient-to-r from-blue-500 via-red-500 to-blue-500"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8">
          
          {/* School Info Section */}
          <div className="lg:col-span-1 space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo.png" 
                alt="PAK School Logo" 
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg object-contain"
              />
              <h3 className="text-lg sm:text-xl font-bold text-blue-400">
                PAK School & College
              </h3>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Nurturing academic excellence and personal development in a dynamic learning environment. 
              Empowering students to reach their full potential.
            </p>
            <div className="flex space-x-3">
              <a 
                href="https://www.facebook.com/pakschoolssystem" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 bg-blue-600 hover:bg-red-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg"
                aria-label="Facebook"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/pakschoolcollege_mardan?igsh=bmw2ZXJsbmJjNnZ4" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-red-500 hover:to-orange-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-base sm:text-lg font-semibold text-white relative pb-2">
              Quick Links
              <div className="absolute bottom-0 left-0 w-8 h-0.5 bg-gradient-to-r from-blue-500 to-red-500"></div>
            </h4>
            <ul className="space-y-2">
              {[
                { name: 'Home', href: '/' },
                { name: 'About Us', href: '/about' },
                { name: 'Admission', href: '/admission' },
                { name: 'Academics', href: '/academics' },
                { name: 'Contact Us', href: '/contact' }
              ].map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href}
                    className="text-sm text-gray-300 hover:text-blue-400 transition-colors duration-300 hover:pl-2 block"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Campus Information */}
          <div className="space-y-4">
            <h4 className="text-base sm:text-lg font-semibold text-white relative pb-2">
              Our Campuses
              <div className="absolute bottom-0 left-0 w-8 h-0.5 bg-gradient-to-r from-blue-500 to-red-500"></div>
            </h4>
            <div className="space-y-3">
              {[
                { name: 'Par Hoti Campus', address: 'Nehr Chowk, Swabi Road Mardan', phone: '0343-0001144/55/66/77' },
                { name: 'DHA Campus', address: 'Muqam Chowk', phone: '0343-0001133' },
                { name: 'SMT Campus', address: 'Phase-2 Sector N, House No.1', phone: '0343-0001122' }
              ].map((campus) => (
                <div key={campus.name} className="bg-gray-800/50 rounded-lg p-3 hover:bg-gray-700/50 transition-colors duration-300">
                  <h5 className="text-sm font-semibold text-blue-400 mb-1">{campus.name}</h5>
                  <p className="text-xs text-gray-300 mb-1">{campus.address}</p>
                  <p className="text-xs text-gray-400">{campus.phone}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Download Section */}
          <div className="space-y-4">
            <h4 className="text-base sm:text-lg font-semibold text-white relative pb-2">
              Downloads
              <div className="absolute bottom-0 left-0 w-8 h-0.5 bg-gradient-to-r from-blue-500 to-red-500"></div>
            </h4>
            <div className="space-y-3">
              <a 
                href="/assets/Newslater.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 bg-gray-800/50 hover:bg-gray-700/50 border border-gray-600 hover:border-blue-500 rounded-lg p-3 transition-all duration-300 hover:translate-x-1 group"
              >
                <svg className="w-4 h-4 text-blue-400 group-hover:text-red-400 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span className="text-sm text-gray-300 group-hover:text-white transition-colors duration-300">Newsletter</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Border */}
        <div className="border-t border-gray-700 pt-6">
          <div className="text-center">
            <p className="text-xs sm:text-sm text-gray-400">
              © Copyright 2025 PAK School & College - Website by{' '}
              <a 
                href="https://technologyinnovision.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-red-400 transition-colors duration-300"
              >
                Technology Innovision
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
